import React from 'react';
import styled from 'styled-components';
import logo from '../../images/ic_text.png';
import backgroundImage from '../../images/ink_utopia.png';
import spotify_advert from '../../images/logos/spotify.png';
import barnesAndNoble from '../../images/logos/barnes-noble-logo.png';
import libro from '../../images/logos/libro_svg.png';
import storytel from '../../images/logos/story_tel_logo.png';
import audiobooks from '../../images/logos/Audiobooks_AppIcon.png';
import googlePlay from '../../images/logos/google_play.png';
import kobo from '../../images/logos/rakuten_kobo.png';
import logoImage from '../../images/ic_text.png';

const Section = styled.section`
  min-height: 100vh;
  width: auto;
  font-family: Lato, sans-serif;
  background: url(${backgroundImage}) top center / cover no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 4rem 2rem;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
  z-index: 1;
`;

const Description = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  max-width: 800px;
  text-align: left;
  color: #333;
  margin-bottom: 2rem;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1.5rem;
  border-radius: 10px;
`;

const ListenButton = styled.div`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  background-color: #BDB5AF;
  color: black;
  padding: 1rem 2rem;
  border-radius: 10px;
  cursor: pointer;
  z-index: 1;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.a`
  display: inline-block;
  width: 80px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const LogoImage = styled.img`
  max-width: 450px;
  height: auto;
  margin-top: 50px;
  margin-bottom: 2rem;
  z-index: 1;
`;

const LandingOne = () => {
  const logoLinks = [
    { logo: barnesAndNoble, link: 'https://www.barnesandnoble.com/w/isadoran-creed-sam-hincks/1145348481' },
    { logo: libro, link: 'https://libro.fm/audiobooks/9798882402692' },
    { logo: storytel, link: 'https://www.storytel.com/se/sv/books/isadoran-creed-book-1-bayesian-sonic-sorcery-3386777' },
    { logo: audiobooks, link: 'https://www.audiobooks.com/audiobook/isadoran-creed-book-1-bayesian-sonic-sorcery/773023' },
    { logo: googlePlay, link: 'https://play.google.com/store/audiobooks/details/Sam_Hincks_Isadoran_Creed?id=AQAAAEBSU2UTJM' },
    { logo: kobo, link: 'https://www.kobo.com/us/en/audiobook/isadoran-creed' },
    { logo: spotify_advert, link: 'https://open.spotify.com/show/5zprhiIHbZ6z93tbQkb4jH?si=fff9003d7beb4d1b' },
  ];

  return (
    <Section>
      <Overlay />
      <LogoImage src={logo} alt="Isadoran Creed Logo" />

      <LogosContainer>
        {logoLinks.map((item, index) => (
          <Logo
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundImage: `url(${item.logo})` }}
          />
        ))}
      </LogosContainer>
      <Title>Audiobook now available</Title>

      <Description>
        Isadoran Creed is an audiobook series set in the fictional Universe of Gaialuna, where the spiritual center of Nimberia is invaded by the evil Tenecheten Warlord Malgroth.
        <br /><br />
        Long the southern lands of Gaialuna had lived in peace under benign Torek leadership. But in recent times, the spirit and unity of the Isadorans has come to dwindle, disturbed by the pervasive force of machines. In their technological addiction, the Isadorans have become energetic shadows of their ancestors, continually tethered to the dopamine rush of Malgroth Tenecheten's digital devices.
        <br /><br />
        But the ancient frequencies of Gaialuna are alive in young Selena Torek, daughter of the Isadoran Chieftain. In an act of sonic sorcery, Selena summons the spirit of her long lost grandfather, who recommends a course of action to combat the Tenecheten threat.
        <br /><br />
        Follow Selena, Malgroth and the other characters of Gaialuna in one of the first in a genre of ultra immersive audiobooks, that give the illusion of a full cast of voice actors. In fact, all voices have been created by the narrator, and exist in the narrator's original voice, before being converted into the timbre of another consenting actor via AI voice cloning technology. Together with two collaborators, the author/narrator of the book has also created the music for Isadoran Creed, mostly via computer synthesis.
        <br /><br />
        The larger aim of the Isadoran Creed is to co-create a fantasy universe together with listeners, who are invited to make their own Isadoran Creed using AI. 
      </Description>
      

    </Section>
  );
};

export default LandingOne;
